import { icons } from 'eva-icons';
import { Injectable } from '@angular/core';
import { SmartTableData } from '../data/smart-table';

@Injectable()
export class SmartTableService extends SmartTableData {
  data = [
    {
      id: 1,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
      icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
      
    },
    {
      id: 2,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 3,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 4,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 5,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 6,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 7,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 8,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 9,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 10,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 11,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 12,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 ><i class="ms-Icon ms-Icon--CircleAdditionSolid" style="font-size:200%" aria-hidden="true"></i></h3><style>h3{margin-left:2%;color:blue}</style>',
    },
    {
      id: 13,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--StatusErrorFull" style="font-size:200%" aria-hidden="true"></i></h3>',
    },
    {
      id: 14,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
    },
    {
      id: 15,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
    },
    {
      id: 16,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
    },
    {
      id: 17,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
    },
    {
      id: 18,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
    },
    {
      id: 19,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
    },
    {
      id: 20,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
    },
  ];
  data_1 = [
    {
      id: 1,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
      icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--StatusErrorFull" style="font-size:200%" aria-hidden="true"></i></span>',
      
    },
    {
      id: 2,
      codeuser: '190000142',
      medicalcode: '19.000152',
      firstName: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--StatusErrorFull" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    {
      id: 3,
      codeuser: '190000142',
      medicalcode: '19.000152',
      username: 'Nguyễn An',
      treatmenttype: 'Nội trú',
      medicaltype: 'Thường',
      department: 'Tai mũi họng',
      diseasecode: 'H.07',
      time: '02/05/2018 - 04/08/2018',
       version: '001',       status: 'Đã tóm tắt',
       icons: '<h3 style="margin-left:2%;color:blue"><i class="ms-Icon ms-Icon--StatusErrorFull" style="font-size:200%" aria-hidden="true"></i></span>',
    },
    
  ];
  getData() {
    return this.data;
  }
  get1Data() {
    return this.data_1;
  }
}
